import { useNavigate, useLocation, useOutletContext } from 'react-router-dom'
import { nextPage } from 'components/RCPro/helpers/nav'
import reactStringReplace from 'react-string-replace'
import Phone from 'components/assets/icons/Phone'
import Envelope from 'components/assets/icons/Envelope'
import Checkbox from 'components/common/Checkbox/Checkbox'
import Arrow from 'components/assets/icons/Arrow'
import Button from 'components/common/Button/Button'
import style from './SignatureChoice.module.scss'
import { useState } from 'react'
import Link from 'components/common/Link/Link'

const RCProSignatureChoice = () => {
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  const [ nextPageTransition ] = useOutletContext()
  const [ choice, setChoice ] = useState(undefined)
  const [ acceptTerms, setAcceptTerms ] = useState(false)
  const { signature, layout: { next } } = state.texts

  const links = [
    {
      text: signature.link1,
      url: ''
    },
    {},
    {
      text: signature.link2,
      url: ''
    }
  ]

  const options = [
    {
      svg: <Phone />,
      text: signature.sms,
      name: 'SMS'
    },
    {
      svg: <Envelope />,
      text: signature.mail,
      name: 'mail'
    }
  ]

  const submit = () => {
    nextPage({ pathname, state, navigate })
    nextPageTransition()
  }

  return (
    <>
      <h1>{signature.title}</h1>

      <ul className={style.choices}>
        {options.map( opt => (
          <li key={`option-${opt.name}`} onClick={() => setChoice(opt.name)} className={choice === opt.name ? style.active : undefined}>
            {opt.svg}
            {opt.text}
          </li>
        ) )}
      </ul>

      <Checkbox
        id="agree"
        className={style.checkbox}
        label={
          reactStringReplace(signature.legalterms, '{{link}}', (match, i) => (
            <Link
              key={`link-${i}`}
              label={links[i-1]?.text}
              to={links[i-1]?.url}
            />
          ))
        }
        onChange={() => setAcceptTerms(!acceptTerms)}
      />

      <Button
        label={<>{next} <Arrow /></>}
        onClick={submit}
        disabled={!choice || !acceptTerms}
        type="primary"
      />
    </>
  )
}

export default RCProSignatureChoice